import { stringIncludesQuery } from './stringIncludesQuery';

import type { SelectOption } from '../Select/SelectOption/SelectOption';

export function baseOptionComparator(
  option: SelectOption,
  query: string
): boolean {
  return stringIncludesQuery(option.label, query);
}
